<ion-header class="page-header">
	<ion-toolbar>
		<ion-title>SalonApp - Richiesta di appuntamento</ion-title>
	</ion-toolbar>
</ion-header>

<ion-content class="landing-content" [fullscreen]="true">
	<div class="hero">
		<div class="hero-shape hero-shape-1"></div>
		<div class="hero-shape hero-shape-2"></div>

		<div class="hero-inner" *ngIf="state === 'ready'">
			<div class="salon-logo">
				<img src="assets/icons/iconbg.png" alt="SalonApp" />
			</div>
			<p class="hero-subtitle">Il team di Supporto SalonApp è pronto ad aiutarti: prenota qui il tuo appuntamento</p>
		</div>
	</div>

	<div class="page-body">
		<div class="state-card error-card" *ngIf="state === 'invalid'">
			<ion-icon name="alert-circle-outline"></ion-icon>
			<h3>Link non valido</h3>
			<p>Il link che hai utilizzato non è corretto o è stato generato in modo errato. Richiedi un nuovo link al Supporto SalonApp.</p>
		</div>

		<div class="state-card error-card" *ngIf="state === 'expired'">
			<ion-icon name="time-outline"></ion-icon>
			<h3>Link scaduto</h3>
			<p>Questo link di prenotazione non è più valido. Contatta il Supporto SalonApp per riceverne uno nuovo.</p>
		</div>

		<ng-container *ngIf="state === 'ready'">
			<div class="info-cards">
				<div class="info-card" *ngIf="false && expirationDate">
					<div class="info-icon expiration">
						<ion-icon name="hourglass-outline"></ion-icon>
					</div>
					<div class="info-text">
						<span class="info-label">Prenota entro</span>
						<span class="info-value">{{ expirationDate | date: 'dd/MM/yyyy' }}</span>
						<span class="info-value-sub">ore {{ expirationDate | date: 'HH:mm' }}</span>
					</div>
				</div>

				<div class="info-card" *ngIf="false && payload?.duration">
					<div class="info-icon duration">
						<ion-icon name="time-outline"></ion-icon>
					</div>
					<div class="info-text">
						<span class="info-label">Durata appuntamento</span>
						<span class="info-value">{{ payload.duration }} minuti</span>
					</div>
				</div>

				<div class="info-card" *ngIf="false && collaboratorsCount">
					<div class="info-icon collaborators">
						<ion-icon name="people-outline"></ion-icon>
					</div>
					<div class="info-text">
						<span class="info-label">Operatori del supporto disponibili</span>
						<span class="info-value">{{ collaboratorsCount }}</span>
					</div>
				</div>
			</div>

			<div class="history-card" *ngIf="loadingAppointments">
				<ion-spinner name="crescent" color="primary"></ion-spinner>
				<span>Verifica appuntamenti precedenti...</span>
			</div>

			<div class="history-card empty" *ngIf="!loadingAppointments && !previousAppointments.length">
				<div class="history-icon">
					<ion-icon name="document-text-outline"></ion-icon>
				</div>
				<div class="info-text">
					<span class="info-label">Storico appuntamenti</span>
					<span class="info-value-sub">Non risultano appuntamenti precedenti con il Supporto SalonApp</span>
				</div>
			</div>

			<div class="history-card accordion" *ngIf="!loadingAppointments && previousAppointments.length">
				<button type="button" class="history-header" (click)="toggleHistory()">
					<div class="history-icon">
						<ion-icon name="document-text-outline"></ion-icon>
					</div>
					<div class="info-text">
						<span class="info-label">Storico appuntamenti</span>
						<span class="info-value">{{ previousAppointments.length }} appuntament{{ previousAppointments.length === 1 ? 'o' : 'i' }}</span>
					</div>
					<ion-icon class="chevron" [name]="historyExpanded ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
				</button>

				<div class="history-list" *ngIf="historyExpanded">
					<div
						class="history-item"
						*ngFor="let appointment of previousAppointments"
						[class.expired]="isAppointmentExpired(appointment)">
						<div class="history-item-date">
							<span class="day">{{ appointment.Support.SupportDate | date: 'dd' }}</span>
							<span class="month">{{ appointment.Support.SupportDate | date: 'MMM' }}</span>
							<span class="year">{{ appointment.Support.SupportDate | date: 'yyyy' }}</span>
						</div>
						<div class="history-item-body">
							<span class="history-item-time">
								<ion-icon name="time-outline"></ion-icon>
								{{ appointment.Support.SupportDate | date: 'HH:mm' }} · {{ appointment.Support.AppointmentDuration }} min
							</span>
						</div>
						<div class="history-item-actions" *ngIf="!isAppointmentExpired(appointment)">
							<button
								type="button"
								class="history-item-edit"
								[disabled]="deletingAppointmentId === appointment.Support.Id"
								(click)="editAppointment(appointment, $event)">
								<ion-icon name="create-outline"></ion-icon>
								Modifica
							</button>
							<button
								type="button"
								class="history-item-delete"
								[disabled]="deletingAppointmentId === appointment.Support.Id"
								(click)="deleteAppointment(appointment, $event)">
								<ion-spinner name="crescent" *ngIf="deletingAppointmentId === appointment.Support.Id"></ion-spinner>
								<ion-icon name="trash-outline" *ngIf="deletingAppointmentId !== appointment.Support.Id"></ion-icon>
								Elimina
							</button>
						</div>
					</div>
				</div>
			</div>

			<div class="booking-card">
				<div class="booking-card-title">
					<ion-icon name="calendar-outline"></ion-icon>
					<span>Scegli data e ora</span>
				</div>

				<div class="editing-banner" *ngIf="editingAppointment">
					<ion-icon name="create-outline"></ion-icon>
					<span>
						Stai modificando l'appuntamento del <strong>{{ editingDateString }}</strong> alle <strong>{{ editingTimeString }}</strong>.
						Vuoi creare un nuovo appuntamento invece? <a href="javascript:void(0)" (click)="cancelEdit()">Clicca qui</a>
					</span>
				</div>

				<div class="booking-layout">
					<div class="calendar-panel">
						<ejs-calendar
							[value]="selectedDate"
							[firstDayOfWeek]="1"
							[min]="minDate"
							[max]="maxDate"
							(change)="onDateChange($event.value)">
						</ejs-calendar>
					</div>

					<div class="slots-panel">
						<div class="slots-loading" *ngIf="loadingSlots">
							<ion-spinner name="crescent" color="primary"></ion-spinner>
							<span>Ricerca disponibilità...</span>
						</div>

						<ng-container *ngIf="!loadingSlots">
							<div class="slots-grid" *ngIf="bookableSlots.length">
								<button
									type="button"
									class="slot-chip"
									*ngFor="let slot of slots"
									[class.selected]="selectedSlot === slot"
									[class.disabled]="!slot.IsBookable"
									[disabled]="!slot.IsBookable"
									(click)="selectSlot(slot)">
									{{ slot.TimeString }}
								</button>
							</div>

							<div class="slots-empty" *ngIf="!bookableSlots.length">
								<ion-icon name="calendar-clear-outline"></ion-icon>
								<span>Nessuna disponibilità per il giorno selezionato</span>
							</div>
						</ng-container>
					</div>
				</div>

				<div class="note-field" *ngIf="bookableSlots.length">
					<label for="appointment-note">Note (opzionale)</label>
					<textarea
						id="appointment-note"
						rows="2"
						placeholder="Aggiungi eventuali informazioni utili..."
						[(ngModel)]="note">
					</textarea>
				</div>

				<button
					type="button"
					class="confirm-button"
					*ngIf="bookableSlots.length"
					[disabled]="!selectedSlot || confirming"
					(click)="confirmAppointment()">
					<ion-spinner name="crescent" *ngIf="confirming"></ion-spinner>
					<ion-icon name="checkmark-circle-outline" *ngIf="!confirming"></ion-icon>
					<span>Conferma</span>
				</button>
			</div>
		</ng-container>
	</div>
</ion-content>
